export const idealPoses = [{
    name: "Virabhadrasana",
    values: [{
        "score": 0.9980351328849792,
        "part": "nose",
        "position": {
          "x": 260.5515543619792,
          "y": 71.42606608072916
        }
      },
      {
        "score": 0.995890736579895,
        "part": "leftEye",
        "position": {
          "x": 245.71101888020837,
          "y": 66.17428588867188
        }
      },
      {
        "score": 0.9650074243545532,
        "part": "rightEye",
        "position": {
          "x": 266.90020751953125,
          "y": 63.09122721354166
        }
      },
      {
        "score": 0.9348471760749817,
        "part": "leftEar",
        "position": {
          "x": 227.68888346354169,
          "y": 69.62837727864583
        }
      },
      {
        "score": 0.6255233883857727,
        "part": "rightEar",
        "position": {
          "x": 278.09857177734375,
          "y": 65.1444091796875
        }
      },
      {
        "score": 0.9987307190895081,
        "part": "leftShoulder",
        "position": {
          "x": 204.89168294270837,
          "y": 122.68902587890625
        }
      },
      {
        "score": 0.9985504746437073,
        "part": "rightShoulder",
        "position": {
          "x": 301.90340169270837,
          "y": 122.86515299479166
        }
      },
      {
        "score": 0.99698406457901,
        "part": "leftElbow",
        "position": {
          "x": 130.90690104166669,
          "y": 135.48455810546875
        }
      },
      {
        "score": 0.9972774386405945,
        "part": "rightElbow",
        "position": {
          "x": 371.9126180013021,
          "y": 141.5910441080729
        }
      },
      {
        "score": 0.9772326350212097,
        "part": "leftWrist",
        "position": {
          "x": 66.90889485677087,
          "y": 134.53057861328125
        }
      },
      {
        "score": 0.9942427277565002,
        "part": "rightWrist",
        "position": {
          "x": 446.006103515625,
          "y": 155.4874267578125
        }
      },
      {
        "score": 0.9978939890861511,
        "part": "leftHip",
        "position": {
          "x": 238.55362955729169,
          "y": 259.09525553385413
        }
      },
      {
        "score": 0.9861001372337341,
        "part": "rightHip",
        "position": {
          "x": 303.6314697265625,
          "y": 263.9161173502604
        }
      },
      {
        "score": 0.9990536570549011,
        "part": "leftKnee",
        "position": {
          "x": 145.80863444010419,
          "y": 324.32914225260413
        }
      },
      {
        "score": 0.9870902299880981,
        "part": "rightKnee",
        "position": {
          "x": 356.95989990234375,
          "y": 347.8638509114583
        }
      },
      {
        "score": 0.9971199035644531,
        "part": "leftAnkle",
        "position": {
          "x": 145.85091145833337,
          "y": 455.12296549479163
        }
      },
      {
        "score": 0.8918182849884033,
        "part": "rightAnkle",
        "position": {
          "x": 412.22947184244794,
          "y": 434.4040120442708
        }
      }
    ],
    angles: [180, 180, 90, 75, 111, 148, 125, 180],
    symmetric: false
  },

  {
    name: "Vrikshasan",
    values: [{
        "score": 0.9888977408409119,
        "part": "nose",
        "position": {
          "x": 326.1503593682418,
          "y": 132.76730969702908
        }
      },
      {
        "score": 0.9959195256233215,
        "part": "leftEye",
        "position": {
          "x": 318.48948632474594,
          "y": 125.50904693075529
        }
      },
      {
        "score": 0.9774076342582703,
        "part": "rightEye",
        "position": {
          "x": 331.7066282912522,
          "y": 124.55213078165548
        }
      },
      {
        "score": 0.9644629955291748,
        "part": "leftEar",
        "position": {
          "x": 305.652367403763,
          "y": 131.26003172983346
        }
      },
      {
        "score": 0.5161184072494507,
        "part": "rightEar",
        "position": {
          "x": 339.1724845067853,
          "y": 131.1485528120945
        }
      },
      {
        "score": 0.9923393726348877,
        "part": "leftShoulder",
        "position": {
          "x": 290.11007109645334,
          "y": 161.860170991363
        }
      },
      {
        "score": 0.9932708144187927,
        "part": "rightShoulder",
        "position": {
          "x": 347.43654434573693,
          "y": 158.0200248111078
        }
      },
      {
        "score": 0.6547285914421082,
        "part": "leftElbow",
        "position": {
          "x": 274.4806888144734,
          "y": 98.71474533345045
        }
      },
      {
        "score": 0.6879208087921143,
        "part": "rightElbow",
        "position": {
          "x": 354.2679464478806,
          "y": 133.27059630291683
        }
      },
      {
        "score": 0.6574694514274597,
        "part": "leftWrist",
        "position": {
          "x": 301.3912053619702,
          "y": 67.93907191926633
        }
      },
      {
        "score": 0.5427832007408142,
        "part": "rightWrist",
        "position": {
          "x": 332.78064640665553,
          "y": 59.54192798442905
        }
      },
      {
        "score": 0.9962214827537537,
        "part": "leftHip",
        "position": {
          "x": 309.7560840857483,
          "y": 283.39964130758
        }
      },
      {
        "score": 0.9983232617378235,
        "part": "rightHip",
        "position": {
          "x": 353.9079763023086,
          "y": 273.85015256677116
        }
      },
      {
        "score": 0.8950284123420715,
        "part": "leftKnee",
        "position": {
          "x": 326.57102675916417,
          "y": 362.81894565041085
        }
      },
      {
        "score": 0.9498437643051147,
        "part": "rightKnee",
        "position": {
          "x": 406.65860270463884,
          "y": 311.5211249222805
        }
      },
      {
        "score": 0.9661123752593994,
        "part": "leftAnkle",
        "position": {
          "x": 330.4120886779574,
          "y": 446.61995118877053
        }
      },
      {
        "score": 0.6587507724761963,
        "part": "rightAnkle",
        "position": {
          "x": 342.72004208680255,
          "y": 311.90577312324285
        }
      }
    ],
    angles: [125, 148, 175, 161, 177, 128, 171, 36],
    symmetry: false
  },
  {
    name: "Tadasana",
    values: [{
        "score": 0.9786602258682251,
        "part": "nose",
        "position": {
          "x": 260.0714605522816,
          "y": 140.9430480745837
        }
      },
      {
        "score": 0.9914114475250244,
        "part": "leftEye",
        "position": {
          "x": 247.28610535723942,
          "y": 139.41215330341694
        }
      },
      {
        "score": 0.9933884143829346,
        "part": "rightEye",
        "position": {
          "x": 260.58903445339536,
          "y": 137.4709185431985
        }
      },
      {
        "score": 0.7817115783691406,
        "part": "leftEar",
        "position": {
          "x": 236.325215587154,
          "y": 140.21989235003514
        }
      },
      {
        "score": 0.7930641174316406,
        "part": "rightEar",
        "position": {
          "x": 272.7087790941285,
          "y": 140.9601864930255
        }
      },
      {
        "score": 0.986181378364563,
        "part": "leftShoulder",
        "position": {
          "x": 229.0990754757786,
          "y": 172.26673904999728
        }
      },
      {
        "score": 0.9973359107971191,
        "part": "rightShoulder",
        "position": {
          "x": 284.1948774397167,
          "y": 158.69087826421926
        }
      },
      {
        "score": 0.6513174176216125,
        "part": "leftElbow",
        "position": {
          "x": 224.86236973534824,
          "y": 118.42631831713612
        }
      },
      {
        "score": 0.970873236656189,
        "part": "rightElbow",
        "position": {
          "x": 282.1154265618242,
          "y": 109.5530526448286
        }
      },
      {
        "score": 0.5962253212928772,
        "part": "leftWrist",
        "position": {
          "x": 248.79045300335213,
          "y": 60.436357016381905
        }
      },
      {
        "score": 0.986257791519165,
        "part": "rightWrist",
        "position": {
          "x": 262.81389261529523,
          "y": 45.665479613835416
        }
      },
      {
        "score": 0.9977415800094604,
        "part": "leftHip",
        "position": {
          "x": 243.25430033858675,
          "y": 282.46612020842343
        }
      },
      {
        "score": 0.9990322589874268,
        "part": "rightHip",
        "position": {
          "x": 284.0820046395167,
          "y": 280.586659784548
        }
      },
      {
        "score": 0.9986045956611633,
        "part": "leftKnee",
        "position": {
          "x": 243.70078623418578,
          "y": 365.01880896545197
        }
      },
      {
        "score": 0.9985162615776062,
        "part": "rightKnee",
        "position": {
          "x": 288.0706626601698,
          "y": 364.8345630474156
        }
      },
      {
        "score": 0.9943217039108276,
        "part": "leftAnkle",
        "position": {
          "x": 241.42600173686208,
          "y": 457.70283735334664
        }
      },
      {
        "score": 0.9877611398696899,
        "part": "rightAnkle",
        "position": {
          "x": 290.36397945839644,
          "y": 451.9910554984861
        }
      }
    ],
    angles: [153, 166, 177, 177, 173, 177, 178, 178],
    symmetry: false
  },
  {
    name: "Natrajasana",
    values: [{
        "score": 0.9884496927261353,
        "part": "nose",
        "position": {
          "x": 236.77604166666669,
          "y": 102.02616373697916
        }
      },
      {
        "score": 0.9786378741264343,
        "part": "leftEye",
        "position": {
          "x": 230.81245930989587,
          "y": 94.21686808268228
        }
      },
      {
        "score": 0.9791767001152039,
        "part": "rightEye",
        "position": {
          "x": 243.52888997395837,
          "y": 95.1180419921875
        }
      },
      {
        "score": 0.19612939655780792,
        "part": "leftEar",
        "position": {
          "x": 231.05094401041669,
          "y": 97.96144612630206
        }
      },
      {
        "score": 0.9789751172065735,
        "part": "rightEar",
        "position": {
          "x": 264.5560302734375,
          "y": 93.57296752929688
        }
      },
      {
        "score": 0.997961163520813,
        "part": "leftShoulder",
        "position": {
          "x": 234.4197998046875,
          "y": 139.84254964192706
        }
      },
      {
        "score": 0.9995005130767822,
        "part": "rightShoulder",
        "position": {
          "x": 290.15928141276044,
          "y": 129.551513671875
        }
      },
      {
        "score": 0.9943583607673645,
        "part": "leftElbow",
        "position": {
          "x": 187.7235107421875,
          "y": 157.46915690104166
        }
      },
      {
        "score": 0.9948022365570068,
        "part": "rightElbow",
        "position": {
          "x": 343.48350016276044,
          "y": 183.90740966796875
        }
      },
      {
        "score": 0.9934513568878174,
        "part": "leftWrist",
        "position": {
          "x": 128.39176432291669,
          "y": 145.01680501302081
        }
      },
      {
        "score": 0.9875425100326538,
        "part": "rightWrist",
        "position": {
          "x": 383.0517578125,
          "y": 230.22674560546875
        }
      },
      {
        "score": 0.9867732524871826,
        "part": "leftHip",
        "position": {
          "x": 270.603759765625,
          "y": 252.863037109375
        }
      },
      {
        "score": 0.99642014503479,
        "part": "rightHip",
        "position": {
          "x": 308.78816731770837,
          "y": 230.61678059895831
        }
      },
      {
        "score": 0.978104293346405,
        "part": "leftKnee",
        "position": {
          "x": 294.736572265625,
          "y": 359.0107014973958
        }
      },
      {
        "score": 0.9894886016845703,
        "part": "rightKnee",
        "position": {
          "x": 325.22397867838544,
          "y": 310.26737467447913
        }
      },
      {
        "score": 0.9922486543655396,
        "part": "leftAnkle",
        "position": {
          "x": 305.68670654296875,
          "y": 461.4879964192708
        }
      },
      {
        "score": 0.974825382232666,
        "part": "rightAnkle",
        "position": {
          "x": 374.93316650390625,
          "y": 251.9521484375
        }
      }
    ],
    angles: [150, 170, 90, 35, 175, 179, 175, 52],
    symmetry: false
  },
  {
    name: "Vasisthasana",
    values: [{
        "score": 0.9389448165893555,
        "part": "nose",
        "position": {
          "x": 471.16033935546875,
          "y": 297.0706787109375
        }
      },
      {
        "score": 0.9768815636634827,
        "part": "leftEye",
        "position": {
          "x": 472.5166015625,
          "y": 283.06717936197913
        }
      },
      {
        "score": 0.7808157801628113,
        "part": "rightEye",
        "position": {
          "x": 481.37286376953125,
          "y": 285.15264892578125
        }
      },
      {
        "score": 0.9681362509727478,
        "part": "leftEar",
        "position": {
          "x": 462.69150797526044,
          "y": 263.2166748046875
        }
      },
      {
        "score": 0.22509711980819702,
        "part": "rightEar",
        "position": {
          "x": 493.3170166015625,
          "y": 286.76385498046875
        }
      },
      {
        "score": 0.9953125715255737,
        "part": "leftShoulder",
        "position": {
          "x": 419.61936442057294,
          "y": 239.99334716796875
        }
      },
      {
        "score": 0.9897290468215942,
        "part": "rightShoulder",
        "position": {
          "x": 451.7692362467448,
          "y": 319.1007080078125
        }
      },
      {
        "score": 0.9914388656616211,
        "part": "leftElbow",
        "position": {
          "x": 394.81964111328125,
          "y": 174.0291748046875
        }
      },
      {
        "score": 0.9913655519485474,
        "part": "rightElbow",
        "position": {
          "x": 452.0701090494792,
          "y": 390.10978190104163
        }
      },
      {
        "score": 0.9715074300765991,
        "part": "leftWrist",
        "position": {
          "x": 378.2467244466146,
          "y": 100.48477172851562
        }
      },
      {
        "score": 0.9961156845092773,
        "part": "rightWrist",
        "position": {
          "x": 479.32879638671875,
          "y": 451.86991373697913
        }
      },
      {
        "score": 0.921006977558136,
        "part": "leftHip",
        "position": {
          "x": 309.18499755859375,
          "y": 320.5041097005208
        }
      },
      {
        "score": 0.9860128164291382,
        "part": "rightHip",
        "position": {
          "x": 328.1971638997396,
          "y": 366.48046875
        }
      },
      {
        "score": 0.9940440058708191,
        "part": "leftKnee",
        "position": {
          "x": 236.25870768229169,
          "y": 388.57169596354163
        }
      },
      {
        "score": 0.8908002376556396,
        "part": "rightKnee",
        "position": {
          "x": 257.1743570963542,
          "y": 416.5645345052083
        }
      },
      {
        "score": 0.9588561654090881,
        "part": "leftAnkle",
        "position": {
          "x": 124.76595052083337,
          "y": 456.8958740234375
        }
      },
      {
        "score": 0.9257192015647888,
        "part": "rightAnkle",
        "position": {
          "x": 158.47684733072919,
          "y": 469.47550455729163
        }
      }
    ],
    angles: [172, 156, 105, 70, 173, 166, 168, 173],
    symmetry: false
  },
  {
    name: "Ustrasana",
    values: [{
        "score": 0.6787958145141602,
        "part": "nose",
        "position": {
          "x": 407.3984781901042,
          "y": 205.33805338541666
        }
      },
      0,
      {
        "score": 0.2589446008205414,
        "part": "rightEye",
        "position": {
          "x": 624.7645390828451,
          "y": 296.704345703125
        }
      },
      0,
      {
        "score": 0.24154387414455414,
        "part": "rightEar",
        "position": {
          "x": 633.2337061564127,
          "y": 299.8299560546875
        }
      },
      0,
      {
        "score": 0.9819802045822144,
        "part": "rightShoulder",
        "position": {
          "x": 341.9469401041667,
          "y": 179.0403849283854
        }
      },
      0,
      {
        "score": 0.31260383129119873,
        "part": "rightElbow",
        "position": {
          "x": 316.23738606770837,
          "y": 269.7634073893229
        }
      },
      0,
      {
        "score": 0.6226877570152283,
        "part": "rightWrist",
        "position": {
          "x": 349.27329508463544,
          "y": 360.1851806640625
        }
      },
      0,
      {
        "score": 0.9843783974647522,
        "part": "rightHip",
        "position": {
          "x": 250.43745930989587,
          "y": 277.63212076822913
        }
      },
      0,
      {
        "score": 0.95574951171875,
        "part": "rightKnee",
        "position": {
          "x": 233.67622884114587,
          "y": 410.2378743489583
        }
      },
      0,
      {
        "score": 0.7424327731132507,
        "part": "rightAnkle",
        "position": {
          "x": 353.10980224609375,
          "y": 394.8712972005208
        }
      }
    ],
    angles: [180, 45, 144, 82],
    symmetry: true
  },
  {
    name: "Bhujangasana",
    values: [{
        "score": 0.9683720469474792,
        "part": "nose",
        "position": {
          "x": 356.7595621744792,
          "y": 230.700927734375
        }
      },
      0,
      {
        "score": 0.7159485816955566,
        "part": "rightEye",
        "position": {
          "x": 365.20806884765625,
          "y": 219.81864420572913
        }
      },
      0,
      {
        "score": 0.5103670358657837,
        "part": "rightEar",
        "position": {
          "x": 366.5704752604167,
          "y": 227.63686116536456
        }
      },
      0,
      {
        "score": 0.9811192750930786,
        "part": "rightShoulder",
        "position": {
          "x": 327.63897705078125,
          "y": 276.06632486979163
        }
      },
      0,
      {
        "score": 0.8145195245742798,
        "part": "rightElbow",
        "position": {
          "x": 311.1915486653646,
          "y": 352.1822102864583
        }
      },
      0,
      {
        "score": 0.6900951862335205,
        "part": "rightWrist",
        "position": {
          "x": 329.53741455078125,
          "y": 410.82389322916663
        }
      },
      0,
      {
        "score": 0.9455678462982178,
        "part": "rightHip",
        "position": {
          "x": 232.70621744791669,
          "y": 388.1187744140625
        }
      },
      0,
      {
        "score": 0.8573753833770752,
        "part": "rightKnee",
        "position": {
          "x": 127.919677734375,
          "y": 410.585693359375
        }
      },
      0,
      {
        "score": 0.8627196550369263,
        "part": "rightAnkle",
        "position": {
          "x": 36.75911458333337,
          "y": 395.31547037760413
        }
      }
    ],
    angles: [160, 30, 143, 135],
    symmetry: true
  }
];
